import axios from "axios";
import store from "@/store";

const customers = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getPayAndGetBook(context,payload){
            let response = await axios.get(`/get_pay_and_get_book/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerRFMTrace(context, payload) {
            let response = await axios.get(`/get_customer_rfm_trace/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerSearchConstants() {
            let response = await axios.get(`/get_customer_search_constant`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCity(context, payload) {
            let response = await axios.get(`/get_city/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getByTitle(context, payload) {
            let response = await axios.post(`/customer_list_by_title`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerFinance(context, payload) {
            let response = await axios.get(`/get_customer_finance/${payload}`,);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerPayBook(context, payload) {
            let response = await axios.get(`/get_pay_Book/${payload}`,);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getActiveCustomer() {
            let response = await axios.get(`/customer_active_list_by_title`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async change_credit(context, payload) {
            let response = await axios.post(`/change_credit/${store.state.userName}/${payload.ecap_customer_id}/${payload.field}/${payload.creditValue}/${'Id' in payload ? payload.Id : null}/${payload.Rejected}`, {"reason": payload.reason});
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async getOrderHistory(context, payload) {
            let response = await axios.get(`/orders_list_by_customerid/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async set_current_location(context, payload) {
            let response = await axios.post(`/set_customer_location/${payload.Cs_ID}`, {
                latitude: payload.latitude,
                longitude: payload.longitude,
                accuracy: payload.accuracy
            });
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async setCustomerInfo(context, payload) {
            let response = await axios.post(`/update_customer_info/${payload.Cs_ID}`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async insertCustomerInfo(context, payload) {
            let response = await axios.post(`/insert_customer_info/${store.state.userName}`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_customer_visit_log(context, payload) {
            let response = await axios.get(`/get_customer_visit_log/${payload.Cs_ID}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_customer_visit_log_by_user(context, payload) {
            let response = await axios.get(`/visit_log_list_by_user/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_customer_city_kind() {
            let response = await axios.get(`/get_customer_city_kind`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async setCustomerVisitLog(context, payload) {
            let response = await axios.post(`/set_customer_visit_log/${store.state.userName}/${payload.Cs_ID}`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_customer_phone_voice(context, payload) {
            let response = await axios.get(`/get_customer_phone_wave_file/${payload}`, {
                responseType: 'blob'
            });
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async getMonthlyCallsInfo() {
            let response = await axios.post(`/get_monthly_calls_info`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_customer_info(context, payload) {
            let response = await axios.get(`/get_customer_info/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_customer_info_by_code(context, payload) {
            let response = await axios.get(`/get_customer_info_by_code/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async get_hava_detail(context, payload) {
            let response = await axios.get(`/hava_detail_list/${payload}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async updateCustomerGoodsInfo(context, payload) {
            let response = await axios.post(`/update_customer_goods_info/${payload.cs_id}`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not push data');
            }
        },
        async set_customer_pay(context, payload) {
            let response = await axios.post(`/set_customer_pay`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async get_customer_pay(context, payload) {
            let response = await axios.get(`/get_customer_pay/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deletePayItem(context, payload) {
            let response = await axios.get(`/delete_pay/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getBanks() {
            let response = await axios.get(`/get_bank`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getComments(context, payload) {
            let response = await axios.post(`/get_user_report`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getUserCommentsPaging(context, payload) {
            let response = await axios.post(`/get_by_user_report_paging`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async createTask(context, payload) {
            let response = await axios.post(`/create_task`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setChequeStatus(context, payload) {
            let response = await axios.post(`/set_cheque_statuc`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getSimpleCustomerList() {
            let response = await axios.get(`/get_simple_customer_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async insertCustomerAccountNumber(context, payload) {
            let response = await axios.get(`/insert_customer_account_number/${payload.Id}/${payload.accountNumber}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateCustomerVisitComment(context, payload) {
            let response = await axios.post(`/update_customer_visit_log/${payload.Id}`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async customerPrintRequest(context, payload) {
            let response = await axios.post(`/customer_print_request`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerTags(context, payload) {
            let response = await axios.get(`/get_customer_tag/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getTags(context, payload) {
            let response = await axios.get(`/get_tags/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async createCustomerTags(context, payload) {
            let response = await axios.post(`/create_customer_tag`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateTags(context, payload) {
            let response = await axios.post(`/update_tags`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        }
    },
    getters: {}
}

export default customers;
